import React, { useState } from "react";
import styled from "@emotion/styled";
import { MyCampo } from "../ui";
import {Btn} from "./../UI-Components/Btn";
import {
  serviceApiResponse,
  serviceApiGet,
  parseJwt,
} from "../ServiciosMaestros/request";
import Script from "react-load-script";
import { Modal } from "../ServiciosMaestros/componentGeneral";
const Container = styled.div`
  position: relative;
`;

function AdminPayments({ identificador, suscripcionProyectoId }) {
  const [epaycoLib, setEpaycoLib] = useState(null);
  const [state, setState] = useState({
    value: "",
    loading: false,
    requestResponse: {},
    openCheckout: false,
  });
  const [modal, setDataModal] = useState({
    open: false,
    type: "success",
    text: "",
  });
  let SetState = (x) => setState(Object.assign({}, state, x));
  let SetModal = (x) => setDataModal(Object.assign({}, state, x));
  const request = async () => {
    const response = await serviceApiResponse(
      {
        identificadorObj: identificador,
        identificador: state.value,
        suscripcionProyectoId: suscripcionProyectoId,
      },
      `/api/suscripciones/administrar`,
      "POST"
    );
    if (response.success) {
      if (response.data.isAdmin) {
        SetState({
          requestResponse: response.data,
          loading: true,
        });
        const dataCheckout = await dataAdministrar(response.data);
        renderCheckout(dataCheckout);
      } else {
        SetState({
          requestResponse: response.data,
          loading: false,
        });
        SetModal({
          open: true,
          type: "info",
          text: `¿Desea programar sus pagos automáticos con ${nombreEmpresa()} en el plan ${
            response.data.nombreProyecto
          }?`,
        });
      }
    }
  };

  /* Open Checkout */
  const renderCheckout = (dataCheckout) => {
    epaycoLib.open({
      createOrder: () => {
        return window.ePayco2.checkout.signature({
          data: dataCheckout,
        });
      },
      onCloseModal: () => {
        SetState({ loading: false });
        console.log("close");
      },
      onFinish: (data) => {
        SetState({ loading: false });
        console.log("onFinish");
      },
    });
  };

  /* Armar la data para Administrar */
  const dataAdministrar = async (response) => {
    const data = await serviceApiGet(process.env.REACT_APP_GEO_IP_URL);
    const ip = data.data;
    return new Promise((resolve, reject) => {
      resolve({
        name: `Administrar-domiciliación`,
        description: `Administrar suscripciones`,
        currency: "COP",
        amount: "0",
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "en",
        ipOrigen: ip,
        subscription: {
          suscriptionProjectId: suscripcionProyectoId,
          parameterSearch: JSON.stringify(response.parameterSearch),
          isAdmin: true,
          suscripcionId: response.suscripcionId,
          accion: "suscribir",
          facturas: null,
          transaccionExtra10: null,
        },
      });
    });
  };

  /* Armar la data para suscribirse a futuros pagos */
  const dataSuscribir = async (response) => {
    const data = await serviceApiGet(process.env.REACT_APP_GEO_IP_URL);
    const ip = data.data;
    return new Promise((resolve, reject) => {
      resolve({
        name: `Suscribir futuros cobros`,
        description: `Domiciliación`,
        currency: "COP",
        amount: "0",
        tax_base: "0",
        tax: "0",
        country: "co",
        lang: "en",
        ipOrigen: ip,
        subscription: {
          suscriptionProjectId: suscripcionProyectoId,
          parameterSearch: JSON.stringify(response.parameterSearch),
          isAdmin: false,
          suscripcionId: null,
          accion: "suscribir",
          facturas: null,
          transaccionExtra10: null,
        },
      });
    });
  };
  const nombreEmpresa = () => {
    const info = JSON.parse(sessionStorage.getItem("informacion"));
    return info.nombreEmpresa || "";
  };

  /* Render suscribir futuras facturas */
  return (
    <Container className={"px-3 pb-3"} id="maincontainer">
      <Script
        url={process.env.REACT_APP_SCRIPT_CHECKOUT}
        onLoad={() => {
          const epayco = window.ePayco2.init({
            configure: {
              key: parseJwt(),
              test: true,
            },
          });
          setEpaycoLib(epayco);
        }}
      />
      <div className="wc px-3">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            SetState({ loading: true });
            request();
          }}
        >
          <div className="wc py-4 mb-3">
            <MyCampo
              label={
                identificador
                  ? `${identificador.titulo_campo}`
                  : "Identificador cliente"
              }
              onchange={(e) => SetState({ value: e.target.value })}
              value={state.value}
              className={"wc"}
              type={"text"}
              disabled={state.loading}
            />
          </div>

          <Btn
            loading={state.loading}
            disabled={state.value.length < 1 || state.loading}
            type={"submit"}
          >
            {state.loading ? "" : "Continuar"}
          </Btn>
        </form>
      </div>

      {/* /////  Modal    /////*/}
      <Modal
        open={modal.open}
        close={() => SetModal({ open: false })}
        message={modal.text}
        tipo={modal.type}
        actions={[
          {
            id: "open-checkout",
            text: "Suscribir",
            onClicK: async () => {
              // suscribirFacturas()
              const dataCheckout = await dataSuscribir(state.requestResponse);
              SetState({ loading: true });
              SetModal({ open: false });
              renderCheckout(dataCheckout);
            },
            disabled: state.loading,
            loading: state.loading,
          },
          {
            text: "Cancelar",
            onClicK: () => SetModal({ open: false }),
            disabled: state.loading,
            tipo: "white",
          },
        ]}
      />
      {/* /////  Modal    /////*/}
    </Container>
  );
}

export default React.memo(AdminPayments);
